import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import OfferChoiceResultRow from "./OfferChoiceResultRow";
import {connect} from "react-redux";
import PrivilegeService from "services/PrivilegeService";
import {useMemo} from "react";
import {shareSystemsActive} from "libs/shareSystems";

const useStyles = makeStyles(theme => ({
    table: {

    },
    headRow: {
    },
    dateTimeColumn: theme.components.table.dateTimeColumn,
    buttonColumn: theme.components.table.buttonColumn,
    statusColumn: theme.components.table.emailColumn,
}));

function OfferChoiceResultTable(
    {
        demandId,
        editable,
        working,
        offerChoiceResultList,
        demandPrivileges,
        demandHeader,
        canDownloadPaper,
        canDownloadFile
    }) {

    const classes = useStyles();
    const showShare = useMemo(() => demandPrivileges.INTEGRATIONS_UPLOAD && shareSystemsActive(demandHeader).length > 0, [demandHeader, demandPrivileges])
    return (<Table className={classes.table}>
        <TableHead>
            <TableRow className={classes.headRow}>
                <TableCell className={classes.partColumn}>{Tr("part")}</TableCell>
                <TableCell className={classes.statusColumn}>{Tr("status")}</TableCell>
                <TableCell className={classes.dateTimeColumn}>{Tr("publish_data")}</TableCell>
                <TableCell className={classes.dateTimeColumn}>{Tr("publish_until_data")}</TableCell>
                <TableCell className={classes.buttonColumn}></TableCell>
                <TableCell className={classes.buttonColumn}></TableCell>
                {showShare && <TableCell className={classes.buttonColumn}></TableCell>}
                <TableCell className={classes.buttonColumn}></TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {
                offerChoiceResultList.items.map((element, index) => {
                    const key = "" + element.identity + element.canceled + element.editable;
                    return <OfferChoiceResultRow
                        key={key} offerChoiceResultItem={element}
                        editable={editable}
                        working={working}
                        demandId={demandId}
                        showShare={showShare}
                        canDownloadFile={canDownloadFile}
                        canDownloadPaper={canDownloadPaper}
                    />
                })
            }
        </TableBody>
    </Table>)
}

OfferChoiceResultTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    editable: PropTypes.bool.isRequired,
    working: PropTypes.bool,
    offerChoiceResultList: PropTypes.shape({
        items: PropTypes.array.isRequired,
    }).isRequired
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    demandPrivileges: state.privileges[PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY]
}))(OfferChoiceResultTable)

